import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import { Observable } from 'rxjs';
import { EventTrackingService } from '../../../../../../../shared/event-tracking/event-tracking.service';
import { fusionStoreToken } from '../../../../../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-right-collapsing-button',
  templateUrl: './right-collapsing-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RightCollapsingButtonComponent {
  faAngleDoubleLeft = faAngleDoubleLeft;
  expanded$: Observable<boolean>;

  private store = inject(fusionStoreToken);
  private fusionStore = inject(fusionStoreToken);
  private eventTrackingService = inject(EventTrackingService);

  constructor() {
    this.expanded$ = this.store('isRightPanelExpanded').$;
  }

  toggleExpanded() {
    const isExpanded = !this.fusionStore.state().isRightPanelExpanded;
    this.fusionStore('isRightPanelExpanded').set(isExpanded);
    this.eventTrackingService.track({
      id: 'toggle_shape_list',
      bucket: 'navigation',
      sub_bucket: 'frame',
      expanded: isExpanded,
    });
  }
}
